import React, {useEffect, useRef, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

import DeviceService from '@user-service/DeviceService';
import SocketProvider from '@user-provider/SocketProvider';
import DeviceHelper from "@helper/DeviceHelper";
import BridgeProvider from "../../provider/BridgeProvider";

const queryString = require('query-string');

const DeviceWaiting = () => {
    const classes = useStyles()
    const query = queryString.parse(window.location.search)
    const isBlocked = query.blocked === 'true'

    // 점검 공지 (TB_CONFIG MAINTENANCE_NOTICE): 조회 완료 전/점검 중에는 연결 흐름을 시작하지 않는다.
    const [maintenanceChecked, setMaintenanceChecked] = useState(false)
    const [maintenance, setMaintenance] = useState(null)

    useEffect(() => {
        DeviceService.getMaintenance().then((notice) => {
            setMaintenance(notice.active ? notice : null)
            setMaintenanceChecked(true)
        })
    }, [])

    const useInterval = (callback, delay) => {
        const savedCallback = useRef();

        useEffect(() => {
            savedCallback.current = callback;
        });

        useEffect(() => {
            const tick = () => {
                savedCallback.current();
            }

            const timerId = setInterval(tick, delay);
            return () => clearInterval(timerId);
        }, [delay]);
    }
    
    useEffect(() => {
        BridgeProvider.instance.closeLoading()
    }, [])
    
    
    useEffect(()=>{
        // 차단된 기기인 경우 자동 연결 시도하지 않음
        if (isBlocked) return
        // 점검 확인 전에는 연결 흐름을 시작하지 않음
        if (!maintenanceChecked) return

        window.app = {
            connectLocalDevice: connectLocalDevice.bind(this),
            serialportLog: serialportLog.bind(this),
        };
        window.app.onVersion = (version) => { BridgeProvider.instance.resolve(version) }

        if (maintenance) {
            // 점검 중: 화면은 차단 상태로 두고 기기 인식만 진행 — 허용 기기(시리얼/회원)인지는
            // C# 이 connectLocalDevice 로 시리얼을 넘길 때 서버에 재판정한다. (버전 업데이트 확인은 생략)
            BridgeProvider.instance.initSocketWithSerialport()
            return
        }

        const configFetch = async () => {
            const res  = await DeviceService.getServerVersion()
            return res.version
        }

        configFetch().then((severVersion) => {
            setTimeout( async () => {
                const pcVersion = await BridgeProvider.instance.getVersion() + ''

                const rPcVersion = parseInt(pcVersion.replace(/\./ig, '' ))
                const rServerVersion = parseInt(severVersion.replace(/\./ig,''))

                if(rPcVersion < rServerVersion && 'desktop' === BridgeProvider.type) {
                    alert('브레인헬스 새로운 버전이 있습니다. (' + severVersion + ')\n 다운로드 후 재시작 합니다.');
                    await BridgeProvider.instance.updateApp('https://cli.brhw.kr/api/update/check')
                } else {
                    await BridgeProvider.instance.initSocketWithSerialport()
                }
            }, 500)
        })
    },[isBlocked, maintenanceChecked, maintenance])

    useInterval(() => {
        // 차단된 기기 / 점검 중에는 재연결 시도하지 않음
        if (isBlocked || !maintenanceChecked || maintenance) return
        BridgeProvider.instance.toReady()
        console.log('to ready')
    }, 3000)

    // 점검 중이면 30초마다 재확인 — 해제(또는 종료 시각 경과) 시 자동으로 정상 흐름 재개
    useInterval(() => {
        if (!maintenance) return
        DeviceService.getMaintenance().then((notice) => {
            if (!notice.active) window.location.reload()
        })
    }, 30000)
    
    const connectLocalDevice = async (computerMac, computerName, roomId, deviceSerial) =>{
        // 점검 중이면 허용 기기(시리얼/회원)인지 서버에 재확인 — 허용이 아니면 점검 화면 유지
        const notice = await DeviceService.getMaintenance({ deviceSerial, computerMac })
        if (notice.active) {
            setMaintenance(prev => prev || notice)   // 이미 점검 화면이면 상태 유지(재인식 루프 방지)
            return
        }
        await SocketProvider.deviceMeasureStop()
        document.location.href = `/login-device?computerMac=${computerMac}&computerName=${computerName}&roomID=${roomId}&deviceSerial=${deviceSerial}`
    }

    const handleExit = async () => {
        await DeviceHelper.exitProgram()
    }
    const serialportLog = (message) => {
        SocketProvider.log('Device Waiting', message)
    }

    return (
        <Box className={classes.root}>
          {maintenance ?
          <Box className={classes.text}>
            {(maintenance.message ? maintenance.message : '서버 점검 중입니다.').split('\n').map((line, i) =>
                <span key={`mt-${i}`}>{line}<br/></span>
            )}
            {maintenance.until &&
            <span style={{fontSize: '1.6rem', letterSpacing: '0.5px', color: '#ffd54f'}}>
                점검 종료 예정 : {maintenance.until}
            </span>
            }
          </Box>
          :
          <Box className={classes.text}>
            브레인 헬스를 시작하고 있습니다 <br/>
            잠시만 기다려 주세요 <br/>
            <span style={{fontSize: '1.1rem', letterSpacing: '0.5px', color: '#aaa'}}>브레인 헬스 기기와 연결을 확인해주세요</span>
          </Box>
          }
          <div className={classes.wrap} />
            <div className={classes.videoWrap}>
                <video src={'https://d2iajcsshqwtw3.cloudfront.net/assets/loginBackground.webm'}
                       poster={'https://d2iajcsshqwtw3.cloudfront.net/assets/poster/loginBackground.png'}
                       autoPlay
                       loop
                       muted
                       style={{width: '100%'}}
                />
            </div>
        </Box>
    )
}

const useStyles = makeStyles(() => ({
    subTitle: {
        fontSize: 22
    },
    root: {
        overflow: 'hidden'
    },
    text: {
        position: 'absolute',
        left: 0,
        top: window.innerHeight / 2 - 100 ,
        zIndex: 3,
        color: 'white',
        width: '100%',
        textAlign: 'center',
        fontSize: 40,
        fontWeight: 500,
        marginBottom: 0,
        letterSpacing: -3
    },
    wrap : {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: window.innerHeight,
        background: '#000',
        zIndex: 1,
        opacity: 0.7,
    },
    videoWrap: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: window.innerHeight,
        background: '#100d14',
        zIndex: 0
    }
}));

export default DeviceWaiting

